import { GOOGLE_API_KEY } from '../constants'

const YOUTUBE_URL = 'https://www.googleapis.com/youtube/v3'

export const fetchDetail = id => {
  return fetch(`${YOUTUBE_URL}/videos?id=${id}&key=${GOOGLE_API_KEY}&part=snippet`)
    .then(response => response.json())
    .catch(error => error.response)
}